(function () {
  // Shared by every static homepage section that wants a scroll-triggered
  // fade+rise instead of just appearing flat on load: How It Works, Trust
  // Badges, Category Grid, Founder Story. Each wraps its items with
  // [data-scroll-reveal-item] inside a [data-scroll-reveal-group]; this
  // file only owns the reveal timing/observation, not the sections
  // themselves.
  const groups = document.querySelectorAll("[data-scroll-reveal-group]");
  if (!groups.length) return;

  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const supportsObserver = "IntersectionObserver" in window;

  groups.forEach((group) => {
    const items = group.querySelectorAll("[data-scroll-reveal-item]");
    if (!items.length) return;

    // Stagger via transition-delay, not animation-delay — these are
    // one-shot reveals (opacity/transform transitions), not repeating
    // @keyframes animations. 110ms/item (not 70ms) so a compact grid like
    // the 8-item category grid — where every item crosses the
    // IntersectionObserver threshold in the same scroll tick — still reads
    // as a visible cascade instead of all firing together.
    items.forEach((item, index) => {
      item.style.transitionDelay = `${index * 110}ms`;
    });

    if (prefersReducedMotion || !supportsObserver) {
      items.forEach((item) => item.classList.add("is-visible"));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.2, rootMargin: "0px 0px -10% 0px" }
    );

    items.forEach((item) => observer.observe(item));
  });
})();
